var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tech-shell"},[_c('TechSidebar'),_c('main',{staticClass:"tech-main"},[_c('TechTopbar'),_c('div',{staticClass:"tech-body"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }